import React from "react";
import { useSelector } from "react-redux";
import { useSIP } from "../../hooks/calls/useSIP";
// import { CallDirection } from "../../constants/SIPEnums";
// import { FaPhoneAlt, FaUser } from "react-icons/fa";
// import { ImPhoneHangUp } from "react-icons/im";
import { formatPhoneNumber } from "../../utils/sipUtilsFunc";
import { PiPhoneCall } from "react-icons/pi";
import { FaRegCirclePause } from "react-icons/fa6";
import { BsFillMicMuteFill } from "react-icons/bs";
import { IoMdKeypad } from "react-icons/io";
import { MdCallEnd } from "react-icons/md";
import { CallDirection } from "../../constants/SIPEnums";
import { FaPhoneAlt } from "react-icons/fa";
import { SessionState } from "sip.js";

const ConnectingScreen = () => {
  const { callDirection, sessionState, sessions, sessionId, dialNumber } = useSelector(
    (state) => state.SIPCalls
  );

  const { endCall, acceptIncomingCall } = useSIP();

  const answerCallHandler = () => {
    const session = sessions[sessionId];

    console.debug("ssdee", session);
    acceptIncomingCall(session);
  };

  const terminateCallHandler = () => {
    endCall();
  };

  return (
    <>
      <div className="callBox">
        <span className="icon">
          <PiPhoneCall />
        </span>
        <p className="number mt-3 mb-2">{formatPhoneNumber(dialNumber)}</p>
        <p className="mt-3 mb-2">
          {callDirection === CallDirection.Inbound
            ? [SessionState.Establishing, SessionState.Established].includes(sessionState)
              ? "Connecting Inbound Call...."
              : "Incoming Call"
            : "Connecting Call"}
        </p>
      </div>

      {callDirection === CallDirection.Inbound ? (
        <>
          <div className="callRunSec">
            <div className="d-flex justify-content-around">
              <button className="callpick btn" onClick={() => answerCallHandler()}>
                <FaPhoneAlt />
              </button>
              <button className="callEndIcon btn" onClick={() => terminateCallHandler()}>
                <MdCallEnd />
              </button>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="callRunSec">
            <div className="iconOpt mb-3">
              <button className="icon" disabled>
                <FaRegCirclePause />
                <p>Hold</p>
              </button>
              <button className="icon" disabled>
                <BsFillMicMuteFill />
                <p>Mute</p>
              </button>
              <button className="icon" disabled>
                <IoMdKeypad />
                <p>Keypad</p>
              </button>
            </div>
            <div>
              <button className="callEndIcon btn" onClick={() => terminateCallHandler()}>
                <MdCallEnd />
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ConnectingScreen;
